import * as React from 'react';

import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { taskAttributes } from '@process-advisor/process-miner/processMiner/processMiner'

let options = [{ value: '', label: '' }]

export const TaskAttributes= () => {

    const [attribute, setAttribute] = React.useState<string>('');

    const onAttributeChange = (attribute: string) => {
        setAttribute(attribute);
        apiProvider.applyAttributeFilter({attributeFilter: attribute})
    }

    React.useEffect(() => {
        options = taskAttributes()
        
        if (options.length > 0) {
            let vtp = []
            vtp['value'] = 'step'
            vtp['label'] = 'Step'
            options.unshift(vtp)    
            setAttribute(options[0].value);
            apiProvider.applyAttributeFilter({attributeFilter: attribute})
        }
    }, []);


    return (
        <Dropdown
            options={options}
            onChange={onAttributeChange}
            value={attribute}/>
    );
};
